import getConfiguration from '@/store/getConfiguration';
import { VendorApi, GetVendorsOutputDTO } from '@/api';
import { showError } from '@/mixins/toastService';

async function getApi() {
  const configuration = await getConfiguration();
  return new VendorApi(configuration, '');
}

type InitialState = {
  partners: GetVendorsOutputDTO;
  isLoadingPartners: boolean;
};

export const initialState = (): InitialState => ({
  partners: { partners: [] },
  isLoadingPartners: false,
});
export type DockPartnerState = ReturnType<typeof initialState>;
type ActionType = {
  commit: Function;
  state: DockPartnerState;
};

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    resetState(state: DockPartnerState) {
      Object.assign(state, initialState());
    },

    setPartners(state: DockPartnerState, partners: GetVendorsOutputDTO) {
      state.partners = partners;
    },
    setLoadingPartners(state: DockPartnerState, isLoading: boolean) {
      state.isLoadingPartners = isLoading;
    },
  },
  actions: {
    async fetchPartners(
      { state, commit }: ActionType,
      { force }: { force?: boolean } = { force: false },
    ) {
      if (state.partners.partners.length > 0 && !force) return;
      try {
        commit('setLoadingPartners', true);
        const api = await getApi();
        const { data } = await api.getVendorsDockschedulingVendorsGet();

        commit('setPartners', data);
      } catch (error) {
        showError('dock-management.error-fetching-partners');
      } finally {
        commit('setLoadingPartners', false);
      }
    },
  },
};
